import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'helpCenterHero.title',
    defaultMessage: 'Help Center',
  },
  loginQuestion: {
    id: 'helpCenterHero.loginQuestion',
    defaultMessage: 'Have XCover protection?',
  },
  loginText: {
    id: 'helpCenterHero.loginText',
    defaultMessage: 'Login to access your personalised help service.',
  },
  loginButtonText: {
    id: 'helpCenterHero.loginButtonText',
    defaultMessage: 'Login',
  },
  welcomeText: {
    id: 'helpCenterHero.welcomeText',
    defaultMessage: 'What would you like help with?',
  },
  quickActionsText: {
    id: 'helpCenterHero.quickActionsText',
    defaultMessage: 'Quick actions',
  },
  makeAClaimText: {
    id: 'helpCenterHero.makeAClaimText',
    defaultMessage: 'Make a claim',
  },
  viewProtectionText: {
    id: 'helpCenterHero.viewProtectionText',
    defaultMessage: 'View your protection',
  },
  updateProfileText: {
    id: 'helpCenterHero.updateProfileText',
    defaultMessage: 'Update your profile',
  },
  protectionText: {
    id: 'helpCenterHero.protectionText',
    defaultMessage: '{partnerName} Protection',
  },
});
